"use strict";
/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchErrorTranslator = exports.fetchTranslator = exports.fetchLocale = exports.i18nReducer = exports.defaultJsonFormsI18nState = void 0;
var tslib_1 = require("tslib");
var i18n_1 = require("../i18n");
var actions_1 = require("../actions");
exports.defaultJsonFormsI18nState = {
    locale: 'en',
    translate: i18n_1.defaultTranslator,
    translateError: i18n_1.defaultErrorTranslator
};
var i18nReducer = function (state, action) {
    var _a, _b, _c, _d, _e, _f;
    if (state === void 0) { state = exports.defaultJsonFormsI18nState; }
    switch (action.type) {
        case actions_1.UPDATE_I18N: {
            var locale = (_a = action.locale) !== null && _a !== void 0 ? _a : exports.defaultJsonFormsI18nState.locale;
            var translate = (_b = action.translator) !== null && _b !== void 0 ? _b : exports.defaultJsonFormsI18nState.translate;
            var translateError = (_c = action.errorTranslator) !== null && _c !== void 0 ? _c : exports.defaultJsonFormsI18nState.translateError;
            if (locale !== state.locale ||
                translate !== state.translate ||
                translateError !== state.translateError) {
                return tslib_1.__assign(tslib_1.__assign({}, state), { locale: locale,
                    translate: translate,
                    translateError: translateError });
            }
            return state;
        }
        case actions_1.SET_TRANSLATOR:
            return tslib_1.__assign(tslib_1.__assign({}, state), { translate: (_d = action.translator) !== null && _d !== void 0 ? _d : i18n_1.defaultTranslator, translateError: (_e = action.errorTranslator) !== null && _e !== void 0 ? _e : i18n_1.defaultErrorTranslator });
        case actions_1.SET_LOCALE:
            return tslib_1.__assign(tslib_1.__assign({}, state), { locale: (_f = action.locale) !== null && _f !== void 0 ? _f : navigator.languages[0] });
        default:
            return state;
    }
};
exports.i18nReducer = i18nReducer;
var fetchLocale = function (state) {
    if (state === undefined) {
        return undefined;
    }
    return state.locale;
};
exports.fetchLocale = fetchLocale;
var fetchTranslator = function (state) {
    if (state === undefined) {
        return i18n_1.defaultTranslator;
    }
    return state.translate;
};
exports.fetchTranslator = fetchTranslator;
var fetchErrorTranslator = function (state) {
    if (state === undefined) {
        return i18n_1.defaultErrorTranslator;
    }
    return state.translateError;
};
exports.fetchErrorTranslator = fetchErrorTranslator;
//# sourceMappingURL=i18n.js.map